import React from "react";
import { NavLink } from "react-router-dom";

var bgimage = require("./../../images/background/bg-site.png");

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.currentstate = {
            logo: require("./../../images/Gewis_Transparent_Custosm_Logo.png"),
        };
    }

    updateFooterLogo = (updatedlogo) => {
        this.currentstate.logo = updatedlogo;
    };

    render() {
        return (
            <>
                <footer className="site-footer footer-large  bg-gewis	footer-wide text-white">
                    {/* FOOTER BLOCKES START */}
                    <div className="footer-top overlay-wraper">
                        <div className="overlay-main" />
                        <div className="container" style={{margin:"auto"}}>
                            <div className="row">
                                {/* ABOUT COMPANY */}
                                <div className="col-lg-3 col-md-6 col-sm-6">
                                    <div className="widget widget_about ">
                                        {/*<h4 class="widget-title">About Company</h4>*/}
                                        <div className="logo-footer clearfix p-b15 ">
                                            <NavLink to={"./"}>
                                                <img
                                                    src={this.currentstate.logo}
                                                    alt=""
                                                />
                                            </NavLink>
                                        </div>
                                        <p className="max-w400  ">
                                            Our goal is to fulfil the wishes of
                                            our customers at a high level. We
                                            happily accept new challenges. We
                                            grow with our projects.
                                        </p>
                                        <ul className="social-icons  mt-social-links">
                                            <li>
                                                <NavLink
                                                    to={"#"}
                                                    className="fa fa-google"
                                                />
                                            </li>
                                            <li>
                                                <NavLink
                                                    to={"#"}
                                                    className="fa fa-rss"
                                                />
                                            </li>
                                            <li>
                                                <NavLink
                                                    to={"#"}
                                                    className="fa fa-facebook"
                                                />
                                            </li>
                                            <li>
                                                <NavLink
                                                    to={"#"}
                                                    className="fa fa-twitter"
                                                />
                                            </li>
                                            <li>
                                                <NavLink
                                                    to={"#"}
                                                    className="fa fa-linkedin"
                                                />
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                {/* RESENT POST */}
                                <div className="col-lg-3 col-md-6 col-sm-6">
                                    <div className="widget widget_address_outer">
                                        <h4 className="widget-title">
                                            Contact Us
                                        </h4>
                                        <ul className="widget_address">
                                            <li>
                                                GeWiS Engineering India Pvt.
                                                Ltd. 705-707, Nyati Emporius,
                                                Radha Chowk,Off Mumbai-Banglore,
                                                Bypass,Baner
                                            </li>
                                            <li>Pune-411045, India</li>
                                            <li>+91-20-67122400</li>
                                            <li>Email: info@gewis.in</li>
                                        </ul>
                                    </div>
                                </div>
                                {/* USEFUL LINKS */}
                                <div className="col-lg-3 col-md-6 col-sm-6 footer-col-3 ">
                                    <div className="widget widget_services inline-links">
                                        <h4 className="widget-title">
                                            Useful links
                                        </h4>
                                        <ul>
                                            <li>
                                                <NavLink to={"/about"}>
                                                    About
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink to={"/project-grid"}>
                                                    Projects
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink to={"/blog-grid"}>
                                                    Services
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink to={"/contactus"}>
                                                    Contact Us
                                                </NavLink>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                {/* NEWSLETTER */}
                            </div>

                        </div>
                    </div>
                    {/* FOOTER COPYRIGHT */}
                    <div className="footer-bottom overlay-wraper ">
                        <div className="overlay-main " />
                        <div className="container ">
                            <div className="row">
                                <div className="mt-footer-bot-right ">
                                    <span className="copyrights-text ">
                                        © 2024 GeWiS. All trademarks are
                                        property of their respective owners
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </>
        );
    }
}

export default Footer;
